import styles from "../styles.module.scss";
import localStyles from "./styles.module.scss";
import {ProductType, useAppData} from "../../context/Contexts";
import {useEffect, useState} from "react";
import {formatMoney, getCurrency, getOfferPrice, isBundle, isFront, isRear} from "../../helpers/helpers";

declare global {
    interface Window {
        is_real_truck?: boolean;
        scs_custom_endpoint?: boolean;
        scs_custom_endpoint_url?: string;
        scs_show_new_year_promo_section?: boolean;
        scs_show_str_section?: boolean;
        scs_show_bf_section?: boolean;
        scs_show_earlybf_section?: boolean;
        scs_bonus_discount?: string;
        scs_bonus_product?: string;
        scs_custom_style?: string;
        scs_product_id?: string;
        Shopify?: ShopifyType;
        country?: string;
        scs_utm_medium?: string;
        scs_utm_campaign?: string;
        scs_utm_source?: string;
        scs_attribution?: string;
        scs_countdown_timer?: string;
        scs_show_timer: string;
    }

    interface ShopifyType {
        country?: string;
    }
}

interface CustomScsParams {
    _scs_utm_medium?: string;
    _scs_utm_campaign?: string;
    _scs_utm_source?: string;
    _scs_attribution?: string;
}

interface ScsProperties {
    _source?: string;
    _seat?: string;
    _color?: string;
    _bonus?: string;
    _bonus_type?: string;
    _widget_id?: string;
    '_your_vehicle'?: string;
    'Your Vehicle'?: string;
}


async function getCustomSku(input: {
    step?: number | undefined;
    seat?: string | undefined;
    color?: string | undefined;
    selectedId?: string | undefined;
    year?: number | undefined;
    make?: string | undefined;
    model?: string | undefined;
    check?: { compatibility: string; compatibility_custom: string; availability: object } | undefined;
    product?: ProductType | undefined;
    originalProduct?: ProductType | undefined;
    addons?: string | undefined;
    trim?: string | undefined;
    has_trims?: boolean | undefined;
    with_bonus?: boolean | undefined
}, sku) {
    const requestOptions: RequestInit = {
        method: "GET",
        redirect: "follow"
    };

    const resp = await fetch(`https://scsbiz.wearevisum.com/api/v1/sku?` +
        `year=${encodeURIComponent(input.year ?? '')}` +
        `&make=${encodeURIComponent(input.make ?? '')}` +
        `&model=${encodeURIComponent(input.model ?? '')}` +
        `&type=${encodeURIComponent(input.seat ?? '')}` +
        `&color=${encodeURIComponent(input.color ?? '')}`, requestOptions);

    const data = await resp.json();

    return data.data;
}

function getSeatCoverId(currentAppData) {


    return currentAppData?.selectedId;
}

export default function StepNav(props) {
    const {currentAppData, setCurrentAppData} = useAppData();

    const [disabled, setDisabled] = useState(true);

    const [product, setProduct] = useState({});

    const [loading, setLoading] = useState(false);

    const [options, setOptions] = useState([]);
    const [price, setPrice] = useState('');
    const [comparePrice, setComparePrice] = useState('');
    const [savings, setSavings] = useState<undefined | string>(undefined);

    function getSeatId() {
        const colorSelected = currentAppData?.color;
        if (colorSelected === undefined) {
            return "46996385366308";
        }
        const colorMapping = {
            "Black": "46996385366308",
            "Black & Grey": "47575557144868",
            "Beige": "46996385333540",
            "Wine Red": "49936887021860",
            "Black & Red": "49936887120164",
            "Black & Blue": "49936887087396",
            "Black & White": "49936887054628",
            "Black & Pink": "46996385366308",
            "Tan": "46996385366308",
        }

        if (!colorMapping.hasOwnProperty(colorSelected)) {
            return "46996385366308";
        }

        return colorMapping[colorSelected];
    }

    useEffect(() => {
        const product1 = currentAppData?.product;
        if (product1 && product1.options) {
            setProduct(product1);
        }
    }, [currentAppData?.product])

    useEffect(() => {
        console.log('product', product);
        const filtered = product && product.variants && product.variants.edges.length > 0 ?
            product.variants.edges.filter(el => el.node.id.replace('gid://shopify/ProductVariant/', '') === '' + currentAppData?.selectedId) : [];
        console.log('filtered', filtered);
        if (filtered.length > 0) {
            const currency = getCurrency(filtered[0].node.priceV2.currencyCode);
            setPrice(currency + '' + parseFloat(filtered[0].node.priceV2.amount).toFixed(0));

            if (filtered[0].node.compareAtPrice) {
                setComparePrice(currency + '' + parseFloat(filtered[0].node.compareAtPrice.amount).toFixed(0));
                setSavings(currency + '' + formatMoney(filtered[0].node.compareAtPrice.amount - getOfferPrice(filtered[0].node.priceV2.amount)));
            } else {
                setComparePrice('');
                if (window.scs_show_earlybf_section) {
                    setSavings(currency + '' + formatMoney(20));
                } else {
                    setSavings(undefined);
                }
            }
        } else {
            setSavings(undefined);
        }
    }, [product, currentAppData?.selectedId]);

    // const handleBack = () => {
    //     setCurrentAppData(prevState => {
    //         return {...prevState, step: prevState.step - 1}
    //     });
    // }
    const handleNext = async () => {
        let element1;

        let id = currentAppData?.selectedId;
        const totalOptions =  currentAppData?.product?.options && currentAppData?.product?.variants.edges.length > 1 ? currentAppData?.product?.options.length : 0;

        if (totalOptions == 0) {
            const only_variant = currentAppData?.product?.variants.edges[0];

            id = only_variant?.node?.id?.replace('gid://shopify/ProductVariant/', '');

            setCurrentAppData(prevState => {
                return {...prevState, selectedId: id}
            })
        }

        if (currentAppData?.step === totalOptions + 1) {
            setLoading(true);
            // console.log(`add to cart\nVehicle: ${currentAppData?.year} ${currentAppData?.make} ${currentAppData?.model}` +
            //     `\nSeat: ${currentAppData?.seat}` +
            //     `\nColor: ${currentAppData?.color}` +
            //     `\nID: ${currentAppData?.selectedId}` +
            //     `\nAddons: ${currentAppData?.addons || ''}`);


            const items: any[] = [];
            const obj1 = {
                quantity: 1,
                id: id,
                properties: getProperties({
                    'Your Vehicle': `${currentAppData.year} ${currentAppData.make} ${currentAppData.model} ${currentAppData.trim}`.trim(),
                    '_your_vehicle': `${currentAppData.year} ${currentAppData.make} ${currentAppData.model} ${currentAppData.trim}`.trim()
                }),
            };

            items.push(obj1);

            var data = {
                items: items,
            };
            // loadingOverlay($(".cart-container form"), "show");
            console.log('data:', data);

            fetch("/cart/add.js", {
                method: "POST",
                body: JSON.stringify(data),
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With":
                        "xmlhttprequest" /* XMLHttpRequest is ok too, it's case insensitive */,
                },
            })
                .then((response) => response.json())
                .then((resp) => {
                    // Do something with the resp
                    // console.log("updated");

                    setLoading(false);

                })
                .catch(function (error) {
                    // console.log("Request failed", error);
                    setLoading(false);
                });

        } else {
            if (currentAppData?.step === 1) {
                if (!currentAppData.year || !currentAppData.make || !currentAppData.model) {
                    alert(`Please select your vehicle`);
                    return;
                }
                setTimeout(function () {

                    if (currentAppData.product?.options) {

                        setCurrentAppData(prevState => {
                            return {
                                ...prevState,
                                step: (prevState && prevState.step ? (prevState.step + 1) : 1),
                                seat: ''
                            }
                        });
                        setTimeout(function () {
                            if (window.innerWidth < 768) {
                                const element = document.getElementById('step_2');
                                element?.scrollIntoView({
                                    behavior: 'smooth'
                                });
                            }
                        }, 50)
                    }
                }, 100)

                return;
            }

            setTimeout(function () {
                if (currentAppData?.step === 2) {
                    if (window.innerWidth < 768) {
                        const element = document.getElementById(`${styles.step_3}`);
                        element?.scrollIntoView({
                            behavior: 'smooth'
                        });
                    }
                }
            }, 200);

            setCurrentAppData(prevState => {
                return {...prevState, step: (prevState && prevState.step ? prevState.step + 1 : 1)}
            });
        }
    }
    // @ts-ignore
    useEffect(() => {
        // console.debug('StepNav: ', currentAppData);
        if (currentAppData?.step === 1) {


            if (currentAppData?.year && currentAppData.make !== '' && currentAppData.model !== '') {
                // console.log('d1');
                // console.log('trim', currentAppData?.trim);
                // console.log('has_trims', currentAppData?.has_trims);
                setDisabled((currentAppData?.has_trims && (!currentAppData?.trim || currentAppData?.trim === '')) || false);
            } else {
                // console.log('d2');
                setDisabled(true);
            }

        }
        if (currentAppData?.step === 2) {
            if (currentAppData.id != '') {
                // console.log('d4');
                setDisabled(false);
            } else {
                // console.log('d5');
                setDisabled(true);
            }
        }

    }, [currentAppData?.check, currentAppData?.step,
        currentAppData?.make, currentAppData?.model, currentAppData?.year,
        currentAppData?.trim, currentAppData?.has_trims,
        currentAppData?.seat, currentAppData?.color]);


    function getButtonText(comparePrice, price): JSX.Element {
        if (window.scs_custom_style == 'style01') {
            if (currentAppData?.step == 1) {
                //  change text based on the following option or add to cart if it is last option

                return (currentAppData?.product?.options && currentAppData?.product?.options.length == 1
                    && currentAppData?.product?.variants.edges.length == 1) ? <>Add To Cart - {comparePrice ? <s>{comparePrice}</s> : ''} {price}</>: (<>Select Options</>);
            }


            if (currentAppData?.step == 2) {
                return <>Add To Cart - {comparePrice ? <s>{comparePrice}</s> : ''} {price}</>;
            }
        } else {
            if (currentAppData?.step == 3) {
                return <>Add To Cart</>;
            }
        }

        return <>Next Step</>;
    }

    return (<>
        <section className={`${localStyles.section__step_nav} ${window.scs_custom_style ? styles.style01 : ''}`}
                 id={`step_nav`}>
            {/*{currentAppData.step > 1 ?
                <button onClick={handleBack} className={`${localStyles.back}`}>Back</button> : ''}*/}
            <button onClick={handleNext} disabled={disabled || loading}
                    className={`${styles.btn} ${loading ? localStyles.loading : ''}`}>
                {loading ? <span className={`${localStyles.loader}`}></span> : ''}
                {currentAppData?.step && currentAppData?.step < 3
                    ? (<span className={`${styles.btn_inner}`}>{getButtonText(comparePrice, price)}
                        <svg width="10" height="15"
                             viewBox="0 0 10 15"
                             fill="none"
                             xmlns="http://www.w3.org/2000/svg">\n' +
                '<path d="M8.78125 6.49731L3.33496 1.05103C2.74902 0.465088 1.80273 0.465088 1.2168 1.05103C0.630859 1.63696 0.630859 2.58325 1.2168 3.16919L5.60547 7.55493L1.2168 11.9407C0.630859 12.5266 0.630859 13.4729 1.2168 14.0588C1.80273 14.6448 2.74902 14.6448 3.33496 14.0588L8.78125 8.61255C9.36426 8.02954 9.36426 7.08032 8.78125 6.49731Z"
                       fill="white"/>\n' +
                '</svg></span>) : (
                        <span className={`${styles.btn_inner}`}>{getButtonText(comparePrice, price)}
                            <svg width="10" height="15"
                                 viewBox="0 0 10 15"
                                 fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M8.78125 6.49731L3.33496 1.05103C2.74902 0.465088 1.80273 0.465088 1.2168 1.05103C0.630859 1.63696 0.630859 2.58325 1.2168 3.16919L5.60547 7.55493L1.2168 11.9407C0.630859 12.5266 0.630859 13.4729 1.2168 14.0588C1.80273 14.6448 2.74902 14.6448 3.33496 14.0588L8.78125 8.61255C9.36426 8.02954 9.36426 7.08032 8.78125 6.49731Z"
                            fill="white"/>
                    </svg>
                </span>)}</button>
        </section>
    </>);
}


function getJumpSeatCoverId(colorId) {

    const colorToJumpSeatCover = {
        'Black': 49988033872164,
        'Brown': 49988033904932,
        'Grey': 49988033937700,
        'Beige': 49988033970468,
        'Wine Red': 49988034003236,

    };

    return typeof colorToJumpSeatCover[colorId] !== 'undefined' ? colorToJumpSeatCover[colorId] : colorToJumpSeatCover['Black'];
}

function getItemObj(id, currentAppData, defaultProps = {}): any {
    const newProps = {
        _seat: currentAppData.seat,
        _color: currentAppData.color,
        _bonus: "exclusive_sale"
    };
    const objb1 = {
        quantity: 1,
        id: id,
        properties: {...newProps, ...defaultProps}
    }
    return objb1;
}

function getProperties(params: ScsProperties) {
    const newParams: CustomScsParams = {};
    if (window.sessionStorage.getItem('attribution')) {
        newParams._scs_attribution = window.sessionStorage.getItem('attribution') || '';
    }
    if (window.sessionStorage.getItem('utm_source')) {
        newParams._scs_utm_source = window.sessionStorage.getItem('utm_source') || '';
    }
    if (window.sessionStorage.getItem('utm_campaign')) {
        newParams._scs_utm_campaign = window.sessionStorage.getItem('utm_campaign') || '';
    }
    if (window.sessionStorage.getItem('utm_medium')) {
        newParams._scs_utm_medium = window.sessionStorage.getItem('utm_medium') || '';
    }

    return {...params, ...newParams};
}